export const ONBOARDING_REACT_QUERY_KEYS = {
	SOLID_PAYMENT_PAGE: 'solid payment page',
	SOLID_MERCHANT_DATA: 'solid merchant data',
	USER_TOKEN: 'user token',
};
